var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "content",
        },
        [
          _c(
            "div",
            { staticClass: "custom-tabs-con" },
            [
              _c(
                "el-tabs",
                {
                  staticClass: "custom-tabs2",
                  on: { "tab-click": _vm.toggleTabs },
                  model: {
                    value: _vm.activeSelectId,
                    callback: function ($$v) {
                      _vm.activeSelectId = $$v
                    },
                    expression: "activeSelectId",
                  },
                },
                _vm._l(_vm.tabsList, function (item, index) {
                  return _c("el-tab-pane", {
                    key: index,
                    attrs: {
                      label: item.label,
                      name: item.id,
                      disabled: item.disabled,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c("form-base-setting", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeSelectId === "1",
                expression: "activeSelectId === '1'",
              },
            ],
            ref: "baseSetting",
          }),
          _c("form-setting", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeSelectId === "2",
                expression: "activeSelectId === '2'",
              },
            ],
            ref: "formSetting",
          }),
          _c("form-process-design", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeSelectId === "3",
                expression: "activeSelectId === '3'",
              },
            ],
            ref: "processDesign",
          }),
          _c("form-pro-setting", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeSelectId === "4",
                expression: "activeSelectId === '4'",
              },
            ],
            ref: "proSetting",
          }),
        ],
        1
      ),
      _c("transition", { attrs: { name: "el-fade-in" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.footer,
                expression: "footer",
              },
            ],
            staticClass: "footer",
            class: [_vm.isCollapsed ? "footer-collapsed" : ""],
          },
          [
            _c(
              "div",
              {
                staticClass: "footer-btn-b",
                on: {
                  click: function ($event) {
                    return _vm.$router.go(-1)
                  },
                },
              },
              [_vm._v("返回")]
            ),
            _vm.activeSelectId !== "1"
              ? _c(
                  "div",
                  {
                    staticClass: "footer-btn-r",
                    on: {
                      click: function ($event) {
                        return _vm.tabsPage("prve")
                      },
                    },
                  },
                  [_vm._v("上一步")]
                )
              : _vm._e(),
            _vm.activeSelectId !== "4"
              ? _c(
                  "div",
                  {
                    staticClass: "footer-btn-r",
                    on: {
                      click: function ($event) {
                        return _vm.tabsPage("next")
                      },
                    },
                  },
                  [_vm._v("下一步")]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "footer-btn-s",
                on: {
                  click: function ($event) {
                    return _vm.validateDesign()
                  },
                },
              },
              [_vm._v("发布")]
            ),
          ]
        ),
      ]),
      _c(
        "w-dialog",
        {
          attrs: { showFooter: false, title: "设置项检查" },
          model: {
            value: _vm.validVisible,
            callback: function ($$v) {
              _vm.validVisible = $$v
            },
            expression: "validVisible",
          },
        },
        [
          _c(
            "el-steps",
            {
              staticClass: "design-steps",
              attrs: {
                "align-center": "",
                active: _vm.validStep,
                "finish-status": "success",
              },
            },
            _vm._l(_vm.validOptions, function (step, i) {
              return _c("el-step", {
                key: i,
                attrs: {
                  title: step.title,
                  icon: step.icon,
                  status: step.status,
                  description: step.description,
                },
              })
            }),
            1
          ),
          _c(
            "el-result",
            {
              staticClass: "result-con",
              attrs: {
                icon: _vm.validIcon,
                title: _vm.errTitle,
                subTitle: _vm.validResult.desc,
              },
            },
            [
              !_vm.validResult.finished
                ? _c("i", {
                    staticClass: "el-icon-loading",
                    staticStyle: { "font-size": "30px" },
                    attrs: { slot: "icon" },
                    slot: "icon",
                  })
                : _vm._e(),
              _vm.validResult.errs && _vm.validResult.errs.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "err-info",
                      attrs: { slot: "subTitle" },
                      slot: "subTitle",
                    },
                    _vm._l(_vm.validResult.errs, function (err, i) {
                      return _c(
                        "ellipsis",
                        {
                          key: i + "_err",
                          attrs: { "hover-tip": "", content: err },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning-outline",
                            attrs: { slot: "pre" },
                            slot: "pre",
                          }),
                        ]
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _c(
                "template",
                { slot: "extra" },
                [
                  _vm.validResult.finished
                    ? _c(
                        "el-button",
                        {
                          staticClass: "btn-submit",
                          attrs: {
                            type: "primary",
                            size: "large",
                            loading: _vm.loading,
                          },
                          on: { click: _vm.doAfter },
                        },
                        [_vm._v(" " + _vm._s(_vm.validResult.action) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }